import React, { useEffect, useState } from "react";
import "./GlobalAccountSearchSideCard.css";
import { Globe, MapPin, Users, Calendar } from "react-feather";
import { fetchAccountInfo } from "../../../../services/accIqService";
import GenericTagComp from "../../genericComponents/tag/GenericTagComp";
import KeyDevelopmentsForAccount from "./keyDevelopmentsForAccount";
import KeyFinancials from "../../AccountDetails/KeyFinancials";
import { useDispatch } from "react-redux";
import { fetchCompFinancialRequest } from "../../../../store/features/actions/companyFinancialsActions";

export default function GlobalAccountSearchSideCard({ data, companyName }) {
  const {
    company_name,
    yearfounded,
    industries = [],
    country,
    region,
    employees,
    description,
    logo,
  } = data;

  const descpp = description?.[0] || "";
  const [loading, setLoading] = useState(false);
  const [recentDevelopmentsData, setRecentDevelopmentsData] = useState([]);
  const [numOfTotalKeyDevelopments, setNumOfTotalKeyDevelopments] = useState(0);
  const [expandDesc, setExpandDesc] = useState(false);
  const [expandIndustries, setExpandIndustries] = useState(false);
  const dispatch = useDispatch();

  const DESC_LIMIT = 400; // show “Show more” only if >400 chars

  const formatEmployees = (val) => {
    if (!val) return "-";
    const num = parseFloat(val);
    if (num >= 1000) return `${(num / 1000).toFixed(1)}k+`;
    return num;
  };

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const resp = await fetchAccountInfo(company_name);
        const keyDevelopmentData = resp?.key_developments || {};
        setNumOfTotalKeyDevelopments(keyDevelopmentData.total || 0);
        setRecentDevelopmentsData(keyDevelopmentData?.results || []);
      } catch (error) {
        console.error("fetchAccountInfo err", error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [company_name]);

  useEffect(() => {
    dispatch(fetchCompFinancialRequest({accountName: company_name}))
  }, [company_name])

  // if (!data) return null;

  const maxVisible = 12;
  const showMoreDesc = descpp.length > DESC_LIMIT;
  const visibleIndustries = expandIndustries
    ? industries
    : industries?.slice(0, maxVisible);
  const hiddenCount = industries.length - maxVisible;

  return (
    <div className="ga-side-card">
      {/* === HEADER (LOGO + COMPANY NAME once) === */}
      {/* <div className="ga-header">
          {logo && <img src={logo} alt={company_name} className="ga-logo" />}
          <h2 className="ga-company-name">{company_name}</h2>
        </div> */}

      {/* === INFO ROW (no borders, inline icons) === */}
      <div className="ga-info-row-container">
        {yearfounded && (
          <div className="ga-info-value">
            <Calendar size={16} />
            {yearfounded}
          </div>
        )}
        {employees && (
          <div className="ga-info-value">
            <Users size={16} />
            {formatEmployees(employees)}
          </div>
        )}
        {country && (
          <div className="ga-info-value">
            <MapPin size={16} />
            {country}
          </div>
        )}
        {region && (
          <div className="ga-info-value">
            <Globe size={16} />
            {region}
          </div>
        )}
      </div>

      {/* === INDUSTRIES === */}
      {industries?.length > 0 && (
        <div className="ga-section">
          <div className="ga-section-title">Industries</div>

          <div className="ga-chips">
            {visibleIndustries.map((ind, i) => (
              <GenericTagComp key={i} text={ind} />
            ))}

            {!expandIndustries && hiddenCount > 0 && (
              <GenericTagComp text={`+${hiddenCount}`} />
            )}
          </div>

          {industries?.length > maxVisible && (
            <div className="ga-show-more-container">
              <button
                className="ga-show-more-btn"
                onClick={() => setExpandIndustries(!expandIndustries)}
              >
                {expandIndustries ? "Show less" : "Show more"}
              </button>
            </div>
          )}
        </div>
      )}

      {/* === DESCRIPTION === */}
      {descpp && (
        <div className="ga-section">
          <div className="ga-section-title">Description</div>
          <div
            className={`ga-desc ${
              expandDesc ? "ga-desc-expanded" : "ga-desc-clamp"
            }`}
          >
            {descpp}
          </div>

          {showMoreDesc && (
            <div className="ga-show-more-container">
              <button
                className="ga-show-more-btn"
                onClick={() => setExpandDesc(!expandDesc)}
              >
                {expandDesc ? "Show less" : "Show more"}
              </button>
            </div>
          )}
        </div>
      )}

      <div className="account_details_wrapper" style={{minHeight: 'none'}}>
        <KeyFinancials companyName={company_name}  />
      </div>

      {/* === KEY DEVELOPMENTS === */}
      <div className="account_details_wrapper" style={{minHeight: 'none'}}>
        <div className="custom_card_block" >
          <div className="ga-section">
            {numOfTotalKeyDevelopments > 0 && (
              <div className="ga-section-title">Key Developments</div>
            )}
            <div className="col-md-12 mb-2">
              <KeyDevelopmentsForAccount
                numOfDevelopments={numOfTotalKeyDevelopments}
                recentDevelopmentsData={recentDevelopmentsData}
                loading={loading}
              />
            </div>
          </div>
        </div>
          
      </div>
      
    </div>
  );
}
